import { callApiV2Get, callApiV3Get } from 'utilities/apiCaller';
import API from 'constants/api';

export const requestNotification = (callbackResponse: (data: any, err: string) => void, target: string = '') => {
    callApiV3Get(`${API.EXCEPTION.GetCount}${target}`, undefined, undefined, true)
        .then(resp => {
            if (resp && resp.data) {
                callbackResponse(resp.data, '')
            }
        })
        .catch((err) => {
            callbackResponse([], err.message)
        });
};

export const requestNotificationV2 = (callbackResponse: (data: any, err: string) => void, target: string = '') => {
    callApiV2Get(`${API.Notifications.TopOpenNotifications}${target}`, undefined, undefined, true)
        .then(resp => {
            if (resp && resp.data) {
                callbackResponse(resp.data, '')
            }
        })
        .catch((err) => {
            callbackResponse([], err.message)
        });
};

